import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ROLES } from '../data/role.data';
import { BaseResponse } from '../models/base.response';
import { FileModel } from '../models/file.model';
import { User } from '../models/user.model';

const endpoints = {
  create: '/user/create',
  update: '/user/update',
  updateAvatar: '/user/update-avatar',
  delete: (userId) => '/user/' + userId,
  getPage: (page: number, query: string, clientId: string, role: string) => {
    const queryObj = {};
    if (query) {
      queryObj['q'] = query;
    }
    if (clientId) {
      queryObj['clientId'] = clientId;
    }
    if (role) {
      queryObj['role'] = role;
    }
    const path = '/user/page/' + page + '?';
    return path + new URLSearchParams(queryObj).toString();
  },
  getAll: (query: string, clientId: string, role: string) => {
    const queryObj = {};
    if (query) {
      queryObj['q'] = query;
    }
    if (clientId) {
      queryObj['clientId'] = clientId;
    }
    if (role) {
      queryObj['role'] = role;
    }
    const path = '/user?';
    return path + new URLSearchParams(queryObj).toString();
  },
  getDetail: (id: string) => '/user/detail/' + id
};

@Injectable()
export class UserService {
  roles = ROLES;

  constructor(
    private http: HttpClient
  ) { }

  create(payload: User): Observable<BaseResponse<User>> {
    const url = environment.apiBaseUrl + endpoints.create;
    return this.http.post<BaseResponse<User>>(url, payload);
  }

  update(payload: User): Observable<BaseResponse<User>> {
    const url = environment.apiBaseUrl + endpoints.update;
    return this.http.post<BaseResponse<User>>(url, payload);
  }

  updateAvatar(payload: FileModel): Observable<BaseResponse<User>> {
    const url = environment.apiBaseUrl + endpoints.updateAvatar;
    return this.http.post<BaseResponse<User>>(url, payload);
  }

  getPage(page: number, query: string, clientId?: string, role?: string): Observable<BaseResponse<User[]>> {
    const url = environment.apiBaseUrl + endpoints.getPage(page, query, clientId, role);
    return this.http.get<BaseResponse<User[]>>(url);
  }

  getAll(query: string, clientId?: string, role?: string): Observable<BaseResponse<User[]>> {
    const url = environment.apiBaseUrl + endpoints.getAll(query, clientId, role);
    return this.http.get<BaseResponse<User[]>>(url);
  }

  getDetail(id: string): Observable<BaseResponse<User>> {
    const url = environment.apiBaseUrl + endpoints.getDetail(id);
    return this.http.get<BaseResponse<User>>(url);
  }

  getUserRole(role: string): string {
    return this.roles[role] || role;
  }

  delete(userId: string): Observable<BaseResponse<any>> {
    const url = environment.apiBaseUrl + endpoints.delete(userId);
    return this.http.delete<BaseResponse<any>>(url);
  }

}
